/* Ondudes: dolny formularz newslettera zapisuje do tej samej listy Klaviyo co popup.
   Używa publicznego Client API Klaviyo (klucz publiczny sklepu). Gdy Klaviyo nie odpowie, formularz wysyła się jak dotąd do Shopify. */
(function () {
  if (window.__onduKlaviyo) return;
  window.__onduKlaviyo = true;
  var cfgEl = document.querySelector('[data-ondu-klaviyo]');
  if (!cfgEl) return;
  var company = cfgEl.getAttribute('data-company');
  var list = cfgEl.getAttribute('data-list');
  var source = cfgEl.getAttribute('data-source') || 'Newsletter na stronie produktu';
  var okText = cfgEl.getAttribute('data-success') || 'Dzięki za zapis! Sprawdź skrzynkę.';
  if (!company || !list) return;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('[class*="ai-newsletter-signup-"]')) return;
    if (form.getAttribute('data-ondu-fallback') === '1') return;
    var input = form.querySelector('input[type="email"]');
    if (!input || !input.value) return;
    e.preventDefault();
    var email = input.value.trim();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      var msg = document.createElement('p');
      msg.className = 'ondu-klaviyo-ok';
      msg.setAttribute('role', 'status');
      msg.textContent = okText;
      msg.style.cssText = 'margin:0;font-size:18px;font-weight:600;';
      form.replaceWith(msg);
    }).catch(function () {
      /* Awaryjnie: zwykła wysyłka do Shopify, jak przed zmianą */
      if (btn) btn.disabled = false;
      form.setAttribute('data-ondu-fallback', '1');
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }, true);
})();